var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 25,
    viewBox: "0 0 158 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4921 15.8833L8.20189 0H0L8.32019 24.9842H16.6719L24.9842 0H16.7823L12.4842 15.8833H12.4921ZM33.8722 0L26.5457 7.3265V17.6814L33.8722 25.0079H44.2271L51.5536 17.6814V7.3265L44.2114 0H33.8722ZM43.7461 17.1924H34.3297V7.7918H43.7461V17.1924ZM61.53 6.86909H53.0994V0H78.0836V6.86909H69.653L69.6372 24.9842H61.53V6.86909Z",
    fill: "#14130F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.1373 15.8833L87.847 0H79.6451L87.9653 24.9842H96.3171L104.629 0H96.4275L92.1294 15.8833H92.1373ZM113.517 0L106.191 7.3265V17.6814L113.517 25.0079H123.872L131.199 17.6814V7.3265L123.856 0L113.517 0ZM123.391 17.1924H113.975V7.7918H123.391V17.1924ZM141.175 6.86909H132.745V0H157.729V6.86909H149.298L149.282 24.9842H141.175V6.86909Z",
    fill: "#14130F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.98447ddfacbfa72ec23ce5ebde2f950e.svg";
export { ForwardRef as ReactComponent };